import React, { useEffect, useState } from 'react';
import styles from './ConnectionStatus.module.css';
import { apiClient } from '../../AxiosConfig';
import NotProtectedAlert from '../NotProtectedModal/NotProtectedAlert';
import ProtectedAlert from '../NotProtectedModal/ProtectedAlert';
import { observer } from 'mobx-react-lite';
import userStore from '../../store/user-store';
import { useQuery } from '@tanstack/react-query';
import UserStore from "../../store/user-store";

const WHITELISTED_IPS = [
  '217.69.7.219', '45.76.179.95', '149.28.28.94', '45.32.230.152',
  '66.55.136.180', '64.176.69.159', '139.84.165.27', '65.20.82.22',
  '140.82.59.182', '149.28.78.56', '64.176.181.91', '70.34.198.133',
  '208.83.239.229', '216.238.76.40', '139.84.130.161', '139.180.182.238',
  '38.180.100.102', '38.180.206.72', '64.176.167.141', '64.176.3.120',
  '65.20.99.0', '66.42.113.17', '207.148.2.222', '64.176.43.48',
  '64.176.229.42', '149.28.215.175', '192.248.155.65', '216.128.177.238',
  '45.76.249.205', '67.219.106.146', '216.238.113.195', '207.246.76.70',
  '139.84.226.152', '38.180.104.57', '130.0.233.102', '95.179.242.52'
];

const translations = {
  en: {
    protected: "Connection Protected",
    notProtected: "Connection Not Protected",
  },
  ru: {
    protected: "Соединение защищено",
    notProtected: "Соединение не защищено",
  }
};

const ConnectionStatus = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initialCheck, setInitialCheck] = useState(true);
  const [isTokenRefresh, setIsTokenRefresh] = useState(false);

  const lang = translations[userStore.langCode] || translations.en;

  const fetchConnectionStatus = async () => {
    const response = await apiClient.get(`/v1/servers/ip`);
    if (response.status === 200) {
      UserStore.setCountryCode(response.data?.countryCode);
    }
    return response.data;

  };


  
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['connectionStatus'],
    queryFn: fetchConnectionStatus,
    refetchInterval: 5000,
    staleTime: 0,
    gcTime: 0,
    enabled:  !isTokenRefresh
  });

  // Обработка полученных данных через useEffect вместо onSuccess
  useEffect(() => {
    if (!data) return;


    const isIpProtected = WHITELISTED_IPS.includes(data.query);
    if (initialCheck && !isIpProtected) {
      const hasShown = localStorage.getItem('ipAlertShown');
      if (!hasShown) {
        setIsModalOpen(true);
      }
    }
    if (initialCheck) {
      setInitialCheck(false);
    }
  }, [data, initialCheck]);

  // Отслеживаем изменения типа подключения и инициируем refetch
  useEffect(() => {
    if ('connection' in navigator) {
      const connection = navigator.connection;
      const handleConnectionChange = () => {
        refetch();
      };

      connection.addEventListener('change', handleConnectionChange);
      return () => {
        connection.removeEventListener('change', handleConnectionChange);
      };
    }
  }, [refetch]);

  if (isLoading) return null;

  if (!data) return null;
  if (data.status === 'fail') return;
  const isProtected = WHITELISTED_IPS.includes(data.query);
  const ipData = data;

  const handleStatusClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (!isProtected) {
      localStorage.setItem('ipAlertShown', 'true');
    }
  };

  return (
    <>
      <div 
        className={`${styles.status_bar} ${isProtected ? styles.protected : styles.not_protected}`}
        onClick={handleStatusClick}
      >
        <span className={styles.icon}>
          {isProtected ? '🔒' : '🔓'}
        </span>
        <span className={styles.text}>
          {isProtected ? lang.protected : lang.notProtected}
        </span>
      </div>

      {isModalOpen && (
        isProtected ? (
          <ProtectedAlert 
            onClose={handleModalClose}
            ipData={ipData}
          />
        ) : (
          <NotProtectedAlert 
            onClose={handleModalClose}
            ipData={ipData}
          />
        )
      )}
    </>
  );
};

export default observer(ConnectionStatus);
